
import { Component, Vue } from 'vue-property-decorator';

import { sharedState } from '../../../../../framework/state';
import { getResource } from '../../../../../framework/client/resource';

import { Vendor } from '../../../../../../common/application/model/Vendor';
import { ApplicationResource } from '../../../../../../common/application/enumeration/ApplicationResource';
import { FileMeta } from '../../../../../../common/application/model/FileMeta';

import { getFileS3, getVendorPurchaseInvoices } from '../../../../client/file_meta_client';
import { formatCurrency, formatToFinnishDate } from '../../../../service/helper_service';
import ParameterService from '../../../../service/parameter_service';

@Component
export default class VendorPurchaseInvoices extends Vue {
    readonly resourceType = ApplicationResource.VENDOR_PURCHASE_INVOICE;
    parameterService = new ParameterService(this.resourceType);

    // State
    shared = sharedState;
    local = {
        row: {} as Vendor,
        loading: false,
        invoices: [] as FileMeta[],
        total: 0,
        parameters: this.parameterService.get(),
    };

    // Functions
    async mounted() {
        if (this.$route.params && this.$route.params.customerId) {
            this.local.parameters.customerId = this.$route.params.customerId.split(',');
            this.parameterService.set(this.local.parameters);
        }

        if (this.$route.params && this.$route.params.vendorId) {
            this.local.parameters.vendorId = this.$route.params.vendorId;
            this.parameterService.set(this.local.parameters);
        }

        await this.loadAsyncData();
    }

    back() {
        this.$router.go(-1);
    }

    async onPageChange(page: number) {
        this.local.parameters.page = page;
        this.parameterService.set(this.local.parameters);
        await this.loadAsyncData();
    }

    get fullAddress(): string {
        if (!this.local.row.vendorAddressStreet) {
            return '';
        }

        return `${this.local.row.vendorAddressStreet}, ${this.local.row.vendorAddressZip} ${this.local.row.vendorAddressCity}`;
    }

    async download(attachment: FileMeta): Promise<void> {
        const result = await getFileS3(this.resourceType, attachment.id, attachment.name);
        const aElement = document.createElement('a');
        aElement.setAttribute('download', attachment.name);
        const href = URL.createObjectURL(result);
        aElement.href = href;
        aElement.setAttribute('target', '_blank');
        aElement.click();
        URL.revokeObjectURL(href);
    }

    get isAdmin(): boolean {
        return this.shared.admin;
    }

    formatDate(date: string): string {
        return formatToFinnishDate(date);
    }

    formatCurrency(sum: number): string {
        return formatCurrency(sum);
    }

    private async loadAsyncData() {
        if (!this.local.parameters.vendorId || !this.local.parameters.customerId) {
            return;
        }

        this.local.loading = true;
        const backendParameters = this.parameterService.getBackendParameters();
        backendParameters.delete('vendorId');

        this.local.row = (await getResource<Vendor>(ApplicationResource.VENDOR, this.local.parameters.vendorId))!!;

        if (!this.isAdmin) {
            backendParameters.set('fileExtension', 'pdf');
        }

        const { invoices, rowCount } = await getVendorPurchaseInvoices(
            this.local.parameters.vendorId,
            backendParameters,
        );
        this.local.invoices = invoices;
        this.local.total = rowCount;
        this.local.loading = false;
    }
}
